import { apiUrl }  from "../constants";
import * as moment from 'moment';
var axios = require('axios');
var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':localStorage.getItem('token'),'Content-Type':'application/json'}
})
export default class PunishedApi {
    static getAll() {
        return request.get('/punished');
    }

    static get(id) {
        return request.get(`/punished?${id}`);
    }

    static create(player) {
        return request.post('/punished',player);
    }

    static edit(player){
        return request.put(`/punished`, player);
    }

    static delete(id){
        return request.delete(`punished?id=${id}`);
    }
}


// WEBPACK FOOTER //
// ./src/api/Punished.js